var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27229_19002)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27229_19002",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27229_19002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 9.14307V13.7145H2.28571V9.14307H0V14.8573C0 15.4885 0.511697 16.0002 1.14286 16.0002H14.8571C15.4883 16.0002 16 15.4885 16 14.8573V9.14307H13.7143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65093 12.5714H10.2849V4.57143H12.5706L7.99913 0L3.42773 4.57143H5.65093V12.5714Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27229_19002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportImage);
export default __webpack_public_path__ + "static/media/exportImage.cb443efcd172e780e2d8f11ddcfa9717.svg";
export { ForwardRef as ReactComponent };